<!--suppress AngularUndefinedBinding, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/koshk" translate>Koshk</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Website Themes</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=Vdc8GR-e3Kc" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<div [hidden]="loading" *ngIf="myBusiness" class="layout-top-spacing">
  <form [formGroup]="form">
    <div class="general-info section bg-white p-3 shadow rounded">
      <div class="row my-3">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <h3 translate>Website Themes</h3>
          <span translate>You will be able to change the invoice's appearance in line with your store's identity. Other than that, the bill will be automated from Paylink.</span>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <h6 translate>Main Attributes</h6>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="defaultLanguage" translate>Default Language</label>
            <div class="input-group">
              <select [ngClass]="{'is-invalid': f.defaultLanguage.errors && submitted}" formControlName="defaultLanguage" class="form-control text-left" id="defaultLanguage">
                <option value="ar">عربي</option>
                <option value="en">English</option>
              </select>
            </div>
            <small class="form-text text-muted" translate>The initial language displayed to the user can be changed through language selection options within the form.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.defaultLanguage.errors && f.defaultLanguage.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.defaultLanguage.errors && f.defaultLanguage.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label translate>Primary Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('primaryColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.primaryColor.errors && submitted}" #primaryColor type="text" formControlName="primaryColor" class="form-control text-left" id="primaryColor">
            </div>
            <small class="form-text text-muted" translate>This is the primary color of the pages. It will also be used for button colors.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.primaryColor.errors && f.primaryColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.primaryColor.errors && f.primaryColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="primaryLightColor" translate>Primary Light Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('primaryLightColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.primaryLightColor.errors && submitted}" #primaryLightColor type="text" formControlName="primaryLightColor" class="form-control text-left" id="primaryLightColor">
            </div>
            <small class="form-text text-muted" translate>This is the light color of the primary color. It will also be used for gradient color.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.primaryLightColor.errors && f.primaryLightColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.primaryLightColor.errors && f.primaryLightColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="secondaryColor" translate>Secondary Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('secondaryColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.secondaryColor.errors && submitted}" #secondaryColor type="text" formControlName="secondaryColor" class="form-control text-left" id="secondaryColor">
            </div>
            <small class="form-text text-muted" translate>This is the secondary color of the pages.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.secondaryColor.errors && f.secondaryColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.secondaryColor.errors && f.secondaryColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>

        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="textColor" translate>Text Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('textColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.textColor.errors && submitted}" #textColor type="text" formControlName="textColor" class="form-control text-left" id="textColor">
            </div>
            <small class="form-text text-muted" translate>This is the color of the text on the webpage.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.textColor.errors && f.textColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.textColor.errors && f.textColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>

        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="backgroundColor" translate>Page Background Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('backgroundColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.backgroundColor.errors && submitted}" #backgroundColor type="text" formControlName="backgroundColor" class="form-control text-left" id="backgroundColor">
            </div>
            <small class="form-text text-muted" translate>It is the specific color used as the page's background, where the form is displayed, typically chosen to match the branding of the company or organization or for a better user experience.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.backgroundColor.errors && f.backgroundColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.backgroundColor.errors && f.backgroundColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="footerColor" translate>Footer Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('footerColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.footerColor.errors && submitted}" #footerColor type="text" formControlName="footerColor" class="form-control text-left" id="footerColor">
            </div>
            <small class="form-text text-muted" translate>This is the footer color of the pages.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.footerColor.errors && f.footerColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.footerColor.errors && f.footerColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="footerBackgroundColor" translate>Footer Background Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('footerBackgroundColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.footerBackgroundColor.errors && submitted}" #footerBackgroundColor type="text" formControlName="footerBackgroundColor" class="form-control text-left" id="footerBackgroundColor">
            </div>
            <small class="form-text text-muted" translate>This is the footer background color of the pages.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.footerBackgroundColor.errors && f.footerBackgroundColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.footerBackgroundColor.errors && f.footerBackgroundColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>

        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="menuTextColor" translate>Menu Text Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('menuTextColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.menuTextColor.errors && submitted}" #menuTextColor type="text" formControlName="menuTextColor" class="form-control text-left" id="menuTextColor">
            </div>
            <small class="form-text text-muted" translate>This is the color of the menu text on the webpage.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.menuTextColor.errors && f.menuTextColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.menuTextColor.errors && f.menuTextColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>

      </div>

      <div class="row my-3">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <h6 translate>Progress Bar</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="showLogo" translate>Show Logo</label>
            <div class="input-group">
              <select [ngClass]="{'is-invalid': f.showLogo.errors && submitted}" formControlName="showLogo" class="form-control" id="showLogo">
                <option value="paylink" translate>Paylink's Logo</option>
                <option value="merchant" translate>Merchant's Logo</option>
                <option value="none" translate>None</option>
              </select>
            </div>
            <small class="form-text text-muted" translate>This is to show the logo above the loading progress bar: either display Paylink's logo, the merchant's logo, or none.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.showLogo.errors && f.showLogo.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.showLogo.errors && f.showLogo.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="progressModalBackground" translate>Popup Window Background Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('progressModalBackground')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.progressModalBackground.errors && submitted}" #progressModalBackground type="text" formControlName="progressModalBackground" class="form-control text-left" id="progressModalBackground">
            </div>
            <small class="form-text text-muted" translate>This is the background color of pop-up windows. Pop-up windows like the progress bar pop-up window.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.progressModalBackground.errors && f.progressModalBackground.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.progressModalBackground.errors && f.progressModalBackground.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
        </div>
      </div>

      <div class="row my-3">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <h6 translate>Button Colors</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-4">

          <div class="form-group">
            <label for="buttonTextColor" translate>Button Text Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('buttonTextColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.buttonTextColor.errors && submitted}" #buttonTextColor type="text" formControlName="buttonTextColor" class="form-control text-left" id="buttonTextColor">
            </div>
            <small class="form-text text-muted" translate>It is the color used for the text displayed on buttons. It is typically chosen for contrast and visibility to make it clear and easy for the user to identify and interact with the button.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.buttonTextColor.errors && f.buttonTextColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.buttonTextColor.errors && f.buttonTextColor.errors.pattern">This field has invalid value</span>
          </div>

        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="buttonHoverTextColor" translate>Over-Button Text Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('buttonHoverTextColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.buttonHoverTextColor.errors && submitted}" #buttonHoverTextColor type="text" formControlName="buttonHoverTextColor" class="form-control text-left" id="buttonHoverTextColor">
            </div>
            <small class="form-text text-muted" translate>It is the specific color used for the text displayed on buttons when the user hovers the cursor over the button, typically chosen to provide visual feedback and indicate interactivity.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.buttonHoverTextColor.errors && f.buttonHoverTextColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.buttonHoverTextColor.errors && f.buttonHoverTextColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="primaryHoverColor" translate>Over-Button Background Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('primaryHoverColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.primaryHoverColor.errors && submitted}" #primaryHoverColor type="text" formControlName="primaryHoverColor" class="form-control text-left" id="primaryHoverColor">
            </div>
            <small class="form-text text-muted" translate>It is the specific color used as a button's background when the user hovers the cursor over the button, typically chosen to provide visual feedback and indicate interactivity.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.primaryHoverColor.errors && f.primaryHoverColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.primaryHoverColor.errors && f.primaryHoverColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <h6 translate>Invoice Attributes</h6>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="foregroundColor" translate>Invoice Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('foregroundColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.foregroundColor.errors && submitted}" #foregroundColor type="text" formControlName="foregroundColor" class="form-control text-left" id="foregroundColor">
            </div>
            <small class="form-text text-muted" translate>This is the background color of the invoice itself.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.foregroundColor.errors && f.foregroundColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.foregroundColor.errors && f.foregroundColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="paymentApprovedColor" translate>Payment Approved Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('paymentApprovedColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.paymentApprovedColor.errors && submitted}" #paymentApprovedColor type="text" formControlName="paymentApprovedColor" class="form-control text-left" id="paymentApprovedColor">
            </div>
            <small class="form-text text-muted" translate>The specific color indicates the status of an approved payment in a user interface.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.paymentApprovedColor.errors && f.paymentApprovedColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.paymentApprovedColor.errors && f.paymentApprovedColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="paymentDeclineColor" translate>Payment Declined Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('paymentDeclineColor')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.paymentDeclineColor.errors && submitted}" #paymentDeclineColor type="text" formControlName="paymentDeclineColor" class="form-control text-left" id="paymentDeclineColor">
            </div>
            <small class="form-text text-muted" translate>The specific color indicates the status of a declined payment in a user interface.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.paymentDeclineColor.errors && f.paymentDeclineColor.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.paymentDeclineColor.errors && f.paymentDeclineColor.errors.pattern">This field has invalid value</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="showPaymentMethods" translate>Show Payment Methods</label>
            <div class="input-group">
              <select [ngClass]="{'is-invalid': f.showPaymentMethods.errors && submitted}" formControlName="showPaymentMethods" class="form-control text-left" id="showPaymentMethods">
                <option value="yes" translate>Yes</option>
                <option value="no" translate>No</option>
              </select>
            </div>
            <small class="form-text text-muted" translate>This is to display or hide the payment methods logos.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.showPaymentMethods.errors && f.showPaymentMethods.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.showPaymentMethods.errors && f.showPaymentMethods.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="hideInvoiceSummery" translate>Hide Invoice Summery</label>
            <div class="input-group">
              <select [ngClass]="{'is-invalid': f.hideInvoiceSummery.errors && submitted}" formControlName="hideInvoiceSummery" class="form-control text-left" id="hideInvoiceSummery">
                <option value="yes" translate>Yes</option>
                <option value="no" translate>No</option>
              </select>
            </div>
            <small class="form-text text-muted" translate>This is to display or hide invoice summary information on the checkout page.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.hideInvoiceSummery.errors && f.hideInvoiceSummery.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.hideInvoiceSummery.errors && f.hideInvoiceSummery.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="hideClientAddress" translate>Hide Client Address</label>
            <div class="input-group">
              <select [ngClass]="{'is-invalid': f.hideClientAddress.errors && submitted}" formControlName="hideClientAddress" class="form-control text-left" id="hideClientAddress">
                <option value="yes" translate>Yes</option>
                <option value="no" translate>No</option>
              </select>
            </div>
            <small class="form-text text-muted" translate>This is to display or hide client address fields on the checkout page.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.hideClientAddress.errors && f.hideClientAddress.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.hideClientAddress.errors && f.hideClientAddress.errors.pattern">This field has invalid value</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="hideVatInvoice" translate>Hide VAT Invoice</label>
            <div class="input-group">
              <select [ngClass]="{'is-invalid': f.hideVatInvoice.errors && submitted}" formControlName="hideVatInvoice" class="form-control text-left" id="hideVatInvoice">
                <option value="yes" translate>Yes</option>
                <option value="no" translate>No</option>
              </select>
            </div>
            <small class="form-text text-muted" translate>This controls whether buyers can download VAT invoices after successful payment. Select 'No' to show VAT invoice download option.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.hideVatInvoice.errors && f.hideVatInvoice.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.hideVatInvoice.errors && f.hideVatInvoice.errors.pattern">This field has invalid value</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="titlePanelBackground" translate>Titles Background Color</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('titlePanelBackground')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.titlePanelBackground.errors && submitted}" #titlePanelBackground type="text" formControlName="titlePanelBackground" class="form-control text-left" id="titlePanelBackground">
            </div>
            <small class="form-text text-muted" translate>This is the background color of the titles on the checkout page.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.titlePanelBackground.errors && f.titlePanelBackground.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.titlePanelBackground.errors && f.titlePanelBackground.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="paymentFormBackground" translate>Payment Form Background</label>
            <div class="input-group">
              <div class="input-group-append">
                <div [style]="loadStyle()">
                  <div class="picker-color" [style]="loadStyleColor('paymentFormBackground')">&nbsp;</div>
                </div>
              </div>
              <input readonly [ngClass]="{'is-invalid': f.paymentFormBackground.errors && submitted}" #paymentFormBackground type="text" formControlName="paymentFormBackground" class="form-control text-left" id="paymentFormBackground">
            </div>
            <small class="form-text text-muted" translate>This is the background color of the payment form on the checkout page.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.paymentFormBackground.errors && f.paymentFormBackground.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.paymentFormBackground.errors && f.paymentFormBackground.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">

        </div>
      </div>

      <div class="row my-3">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <h6 translate>Font Attributes</h6>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="fontFamily" translate>Font Family Name</label>
            <div class="input-group">
              <input (fontPickerChange)="handleFontChange($event)" [(fontPicker)]="defaultFont" [fpWidth]="'320px'" [fpPosition]="'bottom'" [ngClass]="{'is-invalid': f.fontFamily.errors && submitted}" type="text" formControlName="fontFamily" class="form-control text-left" id="fontFamily">
            </div>
            <small class="form-text text-muted" translate>This is a font family name from Google Fonts. Only google fonts are listed here.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.fontFamily.errors && f.fontUrl.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.fontFamily.errors && f.fontUrl.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <div class="form-group">
            <label for="fontUrl" translate>Font URL</label>
            <div class="input-group">
              <input (fontPickerChange)="handleFontChange($event)" [(fontPicker)]="defaultFont" [fpWidth]="'320px'" [fpPosition]="'bottom'" [ngClass]="{'is-invalid': f.fontUrl.errors && submitted}" type="url" formControlName="fontUrl" class="form-control text-left" id="fontUrl">
            </div>
            <small class="form-text text-muted" translate>This is a font URL of Google Fonts. Only google fonts are listed here.</small>
            <span class="invalid-feedback" *ngIf="submitted && f.fontUrl.errors && f.fontUrl.errors.required">This field is required</span>
            <span class="invalid-feedback" *ngIf="submitted && f.fontUrl.errors && f.fontUrl.errors.pattern">This field has invalid value</span>
          </div>
        </div>
        <div class="col-xs-12 col-4">
          <label for="click here" translate>Example of google fonts</label>
          <div class="form-group">
            <h3><a href="https://fonts.google.com/" target="_blank" translate>Click Here</a></h3>
          </div>
        </div>
      </div>

      <div class="as-footer-container">
        <button *ngIf="!submitting" class="btn btn-primary" translate (click)="submitForm()">Save Changes</button>&nbsp;&nbsp;&nbsp;&nbsp;
        <button *ngIf="!submitting" class="btn btn-secondary" translate (click)="resetForm()">Reset Changes</button>&nbsp;&nbsp;&nbsp;&nbsp;
        <button *ngIf="!submitting" class="btn btn-success" translate (click)="createDemoInvoice()">Create Demo Invoice</button>
        <div *ngIf="submitting" class="mx-auto spinner-grow text-info loader-lg"></div>
      </div>

    </div>
  </form>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
